var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"odd"},[_c('div',{staticClass:"odd__panels"},[_c('r-main-panel',[(_vm.routerMode)?_c('odd-router'):_c('odd-objects',{attrs:{"loading":_vm.loading}})],1),(_vm.cardId)?_c('odd-card'):_vm._e()],1),_c('div',{staticClass:"odd__main"},[_c('odd-map',{on:{"map-ready":_vm.setReady,"setLoading":_vm.setLoading}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }